import React, {useEffect, useState} from "react";
import { Nav } from "@/components/navigation/Navbar";
import * as Text from "@/components/text";
import ReactMarkdown from "react-markdown";
import { NextSeo } from "next-seo";
import { getStrapiImage } from "@/utils/strapiFunctions";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import Image from "next/legacy/image";
import Link from "next/link";
import { localeTexts} from "@/utils/locale";

export default function SocialComptroller({ mediaCenter, locale }) {
  const [mediaCenterData, setMediaCenterData] = React.useState({...mediaCenter.attributes});
  
     useEffect(() => {
        if (locale === "en" && mediaCenter.localizations?.data?.length > 0) {
          // Find the English localization
          const englishData = mediaCenter.localizations.data.find(
            (localization) => localization.attributes.locale === "en"
          );
    
          if (englishData) {
            setMediaCenterData({
              ...mediaCenter.attributes, // Preserve other attributes
              ...englishData.attributes, // Override with English attributes
            });
          }
        } else {
          // Reset to the default locale (original attributes)
          setMediaCenterData({ ...mediaCenter });
        }
      }, [locale, mediaCenter.attributes]);
  return (
    <>
      <NextSeo
        title="Contraloría Social - Ambulante"
        description="Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante"
        canonical={`https://ambulante.org/vacantes}`}
        openGraph={{
          url: `https://ambulante.org/vacantes`,
          title: "Contraloría Social - Ambulante",
          description:
            "Información general Coordinación de comunicación Sofía Llorente / slz@ambulante.org Coordinación de prensa Icunacury Acosta / prensa@ambulante.org Boletines 2023 Ambulante Gira de Documentales revela la imagen de su decimoctava edición Anunciamos el arranque de Ambulante Presenta 2023 Materiales Ambulante Presenta 2023 Catálogo Ambulante Presenta 2023 Guía de discusión Las colonias Programas de mano ediciones pasadas Ambulante",
          site_name: "Ambulante",
        }}
      />

      <section className="amb-container">
        {mediaCenter.cover_image ? (
          <div className="relative h-[500px] lg:h-[600px]">
            <div className="absolute inset-0">
              <img
                className="h-full w-full object-cover"
                src={getStrapiImage(mediaCenter.cover_image)}
                alt="Ambulante Contraloría Social"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
          </div>
        ) : null}

        {mediaCenterData.description ? (
          <div className="lg:grid lg:grid-cols-3 lg:gap-4">
            <div className="mt-8 lg:mt-16">
              <Text.Display as="h1" size="sm">
                {localeTexts[locale].common.contraloria}
              </Text.Display>
              <h3 className="mt-7 text-lg uppercase tracking-wider text-gray-500 lg:mt-14">
                {localeTexts[locale].compartir}
              </h3>
              <div className="mt-4 flex gap-5 lg:mt-8">
                <Link
                  href="https://www.facebook.com/AmbulanteAC"
                  passHref
                  target="_blank"
                >
                  <Image
                    alt="facebook icon"
                    className="opacity-60 hover:opacity-100"
                    width={25}
                    height={25}
                    src="/next_assets/img/fb_icon.svg"
                  />
                </Link>
                <Link
                  href="https://twitter.com/Ambulante"
                  passHref
                  target="_blank"
                >
                  <Image
                    alt="twitter icon"
                    className="opacity-60 hover:opacity-100"
                    width={25}
                    height={25}
                    src="/next_assets/img/twitter_icon.svg"
                  />
                </Link>
                <Link
                  href="mailto:?subject=Algo interesante en Ambulante.org&body=https://www.ambulante.org/vacantes/"
                  passHref
                  target="_blank"
                >
                  <Image
                    alt="email icon"
                    className="opacity-60 hover:opacity-100"
                    width={25}
                    height={25}
                    src="/next_assets/img/email_icon.svg"
                  />
                </Link>
              </div>
            </div>
            <div className="mt-10 lg:col-span-2 lg:mt-40">
              <ReactMarkdown className="font-body prose text-lg prose-h2:uppercase lg:max-w-[100ch]">
                {mediaCenterData.description.replace(/<br>/g, "&nbsp; \n")}
              </ReactMarkdown>
            </div>
          </div>
        ) : null}
      </section>
    </>
  );
}

export async function getServerSideProps(context) {
  const { locale } = context.query;
  const q = qs.stringify({
    populate: {
      localizations:"*",
      qa: "*",
      cover_image: "*",
    },
  });
  const { data } = await apiClient.get(`/api/contraloria-social?${q}`);

  return {
    props: {
      mediaCenter: data.data.attributes,
      locale: locale || "es-MX",
    },
  };
}

SocialComptroller.getLayout = function getLayout(page) {
  return (
    <div>
      <div className="amb-container bg-white">
        <Nav theme="light" />
      </div>
      <div>{page}</div>
    </div>
  );
};
